
// Main Google Ads tracking exports
export * from './gtag';
export * from './conversions';
export * from './utmTracking';
export * from './config';

import { initGtag } from './gtag';
import { initUTMTracking } from './utmTracking';

// Initialize Google Ads tracking
export const initGoogleAdsTracking = () => {
  // Initialize gtag
  initGtag();
  
  // Initialize UTM tracking
  initUTMTracking();
  
  console.log('Google Ads tracking initialized with ID: AW-17359318680');
};
